module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.250b795c.ttf";